import { queryOptions } from "@tanstack/react-query";
import { QUERY_KEYS, SHORT_STALE_TIME } from "@/common/api/config";
import { fetchCabinetStatus } from "@/entities/cabinet/api/requests";

export const getCabinetQueryOptions = (token: string) =>
  queryOptions({
    queryKey: [QUERY_KEYS.CABINET_INFORMATION, token],
    queryFn: () => fetchCabinetStatus(token),
    enabled: !!token,
    staleTime: SHORT_STALE_TIME,
    refetchOnWindowFocus: true,
  });
